<template>
    <div>
        <vue-slider ref="slider" v-model="internalValue" :show="show" v-bind:dot-size="10" v-bind:height="165" v-bind:width="10"  v-bind:direction="'vertical'" v-bind:tooltip="'always'"></vue-slider>
    </div>
</template>
<script>

    import Vue from 'vue';
	import vueSlider from 'vue-slider-component';

	export default Vue.component(
	  'volume-slider',
	  {

		  components: {
			  vueSlider
		  },

		  data() {
		      return {
				  internalValue: this.value,
			  }
		  },

		  watch: {

			  // On any v-model changes update intenral value.
			  value: function( newValue ) {

				  this.internalValue = newValue;

			  },

			  // On any internal cahnges update our v-model
			  internalValue: function( internalValue ) {

				  this.$emit('input', this.internalValue);

			  }

		  },

		  props: {

			  show: {
				  required: false,
				  default: true
			  },

			  value: {

			  }

		  }

	  } );
</script>